import { CloseOutlined } from '@ant-design/icons';
import { Waterbody } from '@omniafishing/core';
import { Skeleton } from 'antd';
import pluralize from 'pluralize';
import React from 'react';
import { MapRef } from 'react-map-gl';
import { isDone, isPending, LoadingState } from '../../../../constants/loading_state';
import { useResponsive } from '../../../../hooks/use_responsive';
import styles from './lakes_modal.less';
import { MapLakeCard } from './map_lake_card';
import { ModalNoLakes } from './modal_no_lakes';

interface LakesModalListScreenProps {
  waterbodiesLoadingState: LoadingState;
  mapRef: MapRef;
  waterbodies: Waterbody[];
  onClose: () => void;
}

export const LakesModalListScreen = (props: LakesModalListScreenProps) => {
  const { waterbodiesLoadingState, mapRef, waterbodies, onClose } = props;
  const { isMobile } = useResponsive();

  return (
    <>
      <div className={styles.modalHeader}>
        <span className={styles.heading}>
          <span>
            {isDone(waterbodiesLoadingState) && waterbodies.length === 0
              ? 'No Lakes Found'
              : `${
                  isDone(waterbodiesLoadingState) ? `${waterbodies.length} most popular` : ''
                } ${pluralize('lake', waterbodies.length)} in this area`}
          </span>
        </span>
        <CloseOutlined onClick={onClose} />
      </div>
      <div className={styles.modalContent}>
        <ol className={styles.reportList}>
          {isPending(waterbodiesLoadingState) &&
            Array.from({ length: 6 }, (__, i) => (
              <Skeleton active key={i} paragraph={{ rows: 4 }} />
            ))}
          {isDone(waterbodiesLoadingState) &&
            (waterbodies.length === 0 ? (
              <ModalNoLakes
                mapRef={mapRef}
                onClick={() => {
                  if (isMobile) {
                    onClose();
                  }
                }}
              />
            ) : (
              waterbodies.map((waterbody) => {
                return (
                  <li key={waterbody.id}>
                    <MapLakeCard waterbody={waterbody} />
                  </li>
                );
              })
            ))}
        </ol>
      </div>
    </>
  );
};
